export default {
  navigator: {
    home: '首页',
    achievements: '科研成果',
    researcher: '科研学者',
    ins: '科研机构',
    isme: '成果认领',
    apply: '服务申请'
  },
  home: {
    title: '深圳北理莫斯科大学学术研究平台',
    introduce: '深圳北理莫斯科大学是国家主席习近平、俄罗斯总统普京达成重要共识，由深圳市人民政府、北京理工大学和莫斯科国立罗蒙诺索夫大学（简称“莫斯科大学”）三方合作设立的具有独立法人资格的中外合作大学。学校以建设独具特色的世界一流国际化综合性研究型大学为目标，致力于开展精英教育以及高水平科学研究和创新活动。2016年10月，学校获教育部批准正式设立。2017年学校招收首批本科生和硕士研究生，2018年招收首批博士研究生，2020年获批博士后创新实践基地，2021年入选广东省高水平大学重点学科建设高校。',
    insRepository:"机构知识库",
    article: '论文',
    patent: '专利',
    researcher: '科研学者',
    software_copyright: '软件著作权',
    award: '奖项',
    project: '项目',
    report: '报告',
    book: '专著',
    data: '数据',
    news: {
      left_title: '最新科研成果',
      right_title: '机构科研主题',
      more: '更多',
    },
    login: '登录',
    signout: '退出登录',
    settings: '账号设置',
    profile: '我的主页',
    historySearch:'检索历史',
    history:'浏览历史',
    search: {
      placeholder: '发现你感兴趣的内容...',
      advanceSearch: '高级检索',
      search: '检索',
      topic: '主题',
    },
    appJoin: "申 请 加 入",
    ins: "机构",
    colleges: "高校",
    cas: "中国科学院",
    scholar_count: "学者数",
    fruit_count: "成果数",
    journal_article_submit:"期刊论文交存",
    person_fruit_submit:"个人成果交存",
  },
  explore: {
    category: '分类浏览',
    years: '时间范围',
    start: '开始时间',
    end: '结束时间',
    to: '至',
    enter: '输入',
    exact: '精确',
    fuzzy: '模糊',
    reset: '重置条件',
    article: {
      title: '标题',
      keywords: '关键词',
      author: '作者',
      institution: '机构',
      publication: '出版物',
      abstract: '摘要',
      doi: 'DOI',
      type: '论文类型',
      year: '出版年',
      collect: '核心收录',
      lang: '语种',
      authorIns: '作者机构',
      fundIns: '基金资助机构',
      licence: '使用许可',
      subject: "学科领域",
    },
    patent: {
      title: '专利名',
      inventor: '发明人',
      applicant: '专利权人',
      abstract: '摘要',
      apply_number: '申请号',
      issue_number: '公开号',
      apply_year: '申请年',
      issue_year: '公开年',
      subject: '领域分类',
      type: '专利类型',
      country: '国家/地区',
      ipc: 'IPC分类',
      cpc: 'CPC分类',
    },
    report: {
      title: '标题',
      keywords: '关键词',
      abstract: '摘要',
      type: '报告类型',
      institution: '机构',
      year: '报告时间',
      source: '报告来源',
      subject: "学科领域",
    },
    book: {
      title: "书名",
      publisher: "出版社",
      author: "作者",
      keywords: "关键词",
      abstract: "摘要",
      type: "专著类型",
      year: "出版时间",
      ins: "主编机构",
      subject: "学科领域",
    },
    scienceData: {
      title: '标题',
      keywords: '关键词',
      author: "作者",
      abstract: '摘要',
      subject: '学科领域',
      year: '发布时间',
      ins: '机构',
      licence: '使用许可',
      data_type: '数据类型',
      file_type: '文件格式',
    },
    project: {
      title: '标题',
      keywords: '关键词',
      author: '负责人',
      fundIns: '资助机构',
      country: '资助国家',
      abstract: '摘要',
      underIns: '承担机构',
      startYear: '开始年',
      status: '项目状态',
      type: '项目类型',
      lang: '项目语种',
      fundAmout: '资助金额',
      subject: '学科领域',
    },
    award: {
      title: '标题',
      abstract: '摘要',
      level: '奖项级别',
      category: "获奖等级",
      year: "获奖时间",
      ti_ins: "提名机构",
      ins: "获奖机构",
    },
    software: {
      title: '标题',
      abstract: '摘要',
      author: '著作权人',
      inventor: "开发人",
      year: "发证时间",
      ins: "著作机构",
      method: "获取方式",
      range: "权利范围",
      registId: "登记号",
      getMethod: "权利取得方式",
    },
    institution: {
      title: '机构名',
      subject: '研究领域',
      intro: '简介',
      city: '城市',
      country: '国家',
      tag: '标签',
      type: '机构类型',
    },
    all_selected: "全选",
    date_sorted: '时间排序',
    related_sorted: '相关排序',
    fulltext: "全文",
    unit: '条数据',
    filter: '筛选',
    all: '全部',
    related: '相关度',
    name: '名字',
    count_paper: '发文数',
    asc: "升序",
    desc: "降序",
    reasearch: "研究方向",
    people_category: "人员类别",
    research_unit: "研究单元",
    units: '请选择研究单元',
    group: '请选择课题组',
    empty: '暂无数据',
    selectCondtion: '筛选条件',
    allDelete: '全部清除',
    selected: '已选择',
    cancelSelected: '取消选择',
    exportText: '导出',
  },
  service_apply: {
    label1:"PubScholar机构知识云",
    label1_1:"PubScholar机构知识云平台基于中国科学院机构资产管理与知识服务、机构竞争评估与学科评估和平台网络信息安全三方面需求，利用大数据和人工智能技术，提升机构知识成果的管理水平和利用深度，提供机构科研成果数据资产化管理、机构科研实力对外展示、团队成果多维度统计分析、支撑机构竞争与学科竞争评估等，并助力科研人员高水平学术资源的有效汇集，打通科研成果共享利用。平台自2023年11月正式上线，目前已有20余家科研机构和高校入驻。",
    label2: 'PubScholar机构知识云平台诚邀机构入驻',
    label3: '机构知识云服务平台的申请人一般为机构科技处或图书馆管理人员。申请人需要先填写',
    label3_1: '发送至平台管理员，平台管理员审核后与申请人对接机构数据和开通机构知识库云服务。',
    label4: '机构入驻申请流程（申请人一般为机构科技处或图书馆管理人员）',
    label5: '（1）申请人访问机构知识云平台下载',
    label5_1: '进行填写。',
    label6: '（2）申请人通过邮件将填写的申请表发送至平台管理员邮箱hujy@mail.las.ac.cn。',
    label7: '（3）平台管理员收到申请后进行审核，审核周期为3个工作日内。',
    label8: '（4）平台管理员审核后与申请人进行数据对接，完成机构数据的导入、清洗和规范建设。',
    label9: '（5）平台管理员为申请机构开通机构知识库云服务，并为机构管理员授权机构知识库后台管理平台的管理权限设。',
    label10: '服务申请表下载',
    label11: '《开通机构知识云服务申请表》',
    label12: '平台联系方式',
    label13: '您在使用本平台过程中，如有任何要求、疑问或者建议，均可通过以下方式与我们取得联系，我们将认真地处理您的问题。',
    label14: '邮箱：hujy@mail.las.ac.cn；zhangrumin@mail.las.ac.cn',
    label15: '电话：010-82628382'
  },
  footer: {
    operator: '中国科学院文献情报中心',
    operatorLabel: '运营单位：',
    contactAddressLabel: '联系地址：',
    contactAddress: '北京市海淀区北四环西路33号',
    contactNumberLabel: '联系电话：',
    contactNumber: '010-82628382',
    copyright: '中国科学院文献情报中心 版权所有'
  }
}
